export enum SortDirection {
  ASCENDING,
  DESCENDING
}

export enum SortState {
  INACTIVE,
  REVERTED,
  DEFAULT
}
